export default __webpack_public_path__ + "static/media/2412251.453e43e6.jpg";